import { useState, type Dispatch, type SetStateAction } from 'react'

import { type IEditFeedback, type IFeedbackDto, type IFeedbackMode } from '@/app/types/doctorsType'
import { Button } from '@/shared'

import { PublishFeedback } from './AddFeedback/PublishFeedback'
import style from './Mode.module.scss'
import { SortingButton } from './SortingButton'

interface IProps {
    mode: IFeedbackMode[]
    isPublished: boolean
    setMode: Dispatch<SetStateAction<IFeedbackMode[]>>
    setState: Dispatch<SetStateAction<IEditFeedback[]>>
    onAddFeedback: (dto: Omit<IFeedbackDto, 'doctorId'>, onSuccess: () => void) => void
    isFetchingFeedbacks: boolean
}

export type TSortingFlag = 'up' | 'down'

export const Mode = (props: IProps) => {
    const { mode, setMode, onAddFeedback, setState, isPublished, isFetchingFeedbacks } = props
    const [showAddFeedback, setShowAddFeedback] = useState<boolean>(false)
    const [sortFlag, setSortFlag] = useState<TSortingFlag>('up')

    const onClosePublishModal = () => {
        setShowAddFeedback(false)
    }

    const onOpenPublishModal = () => {
        setShowAddFeedback(true)
    }

    const onHandleSort = () => {
        sortFlag === 'down' && setState((prev) => [...prev.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))])
        sortFlag === 'up' && setState((prev) => [...prev.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1))])
        setSortFlag((val) => (val === 'up' ? 'down' : 'up'))
    }
    return (
        <div className={style.container}>
            <PublishFeedback
                show={showAddFeedback}
                onClose={onClosePublishModal}
                onAddFeedback={onAddFeedback}
                isFetchingFeedbacks={isFetchingFeedbacks}
                setMode={setMode}
            />
            <div className={style.mode}>
                {mode.map((mode) => (
                    <div
                        key={mode.title}
                        onClick={() => setMode((prev) => prev.map((item) => ({ ...item, isChecked: !item.isChecked })))}
                    >
                        <div className={style.radioContainer}>
                            {mode.isChecked && <div className={style.checked} />}
                        </div>
                        <span>{mode.title}</span>
                    </div>
                ))}
            </div>
            <div className={style.btn}>
                {!isPublished && (
                    <Button onClick={onHandleSort}>
                        <SortingButton
                            flag={sortFlag}
                            arrowStyle={style.arrow}
                            arrowWrapperStyle={style.arrowWrapper}
                        />
                    </Button>
                )}
                <Button onClick={onOpenPublishModal}>Добавить отзыв</Button>
            </div>
        </div>
    )
}
